export default __webpack_public_path__ + "static/media/logo.b166c308.svg";